import React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { useModal, DropdownItem } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { DeleteListsForm } from '@vlabs/monokit/entities/lists';

import st from './DeleteListsDropdownItem.module.sass';
import type { DeleteListsProps } from './types';
import { useDeleteLists } from './useDeleteLists';

const displayName = 'DeleteListsDropdownItem';

function DeleteListsDropdownItem({
  listIds,
}: DeleteListsProps): React.JSX.Element {
  const { t } = useTranslation();
  const modal = useModal({ size: 'small' });
  const deleteLists = useDeleteLists();

  return (
    <React.Fragment>
      {modal.wrap(
        <DeleteListsForm
          listIds={listIds}
          onCancel={modal.close}
          onSubmit={async (values) => {
            await deleteLists.mutateAsync(values);
            modal.close();
          }}
        />,
      )}

      <DropdownItem
        className={st.DeleteListsDropdownItem}
        label={t('features:delete_lists.button')}
        leftIcon={<DeleteIcon />}
        onClick={modal.open}
      />
    </React.Fragment>
  );
}

DeleteListsDropdownItem.displayName = displayName;

export { DeleteListsDropdownItem };
